module.exports = __webpack_public_path__ + "static/studio-b-preamps-4e2b9d9cfa89f20a47efbdefabad8684.jpg";